import { Module } from 'vuex-smart-module';
import FilesActions from './actions';
import FilesGetters from './getters';
import FilesMutations from './mutations';
import FilesState from './state';

export default new Module({
  state: FilesState,
  mutations: FilesMutations,
  actions: FilesActions,
  getters: FilesGetters,
});
